export function ErrorFallback() {
  return (
    <div className="flex h-screen items-center justify-center flex-col gap-4 p-8 text-center">
      <h1 className="text-2xl font-semibold text-gray-900">Something went wrong</h1>
      <p className="text-gray-500 max-w-sm">
        An unexpected error occurred. Our team has been notified. Try refreshing the page.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="px-4 py-2 bg-orange-600 text-white rounded-md hover:bg-orange-700 transition-colors"
      >
        Reload page
      </button>
    </div>
  );
}
